// const datasetServicetUrl = '/services/plugin-asset-metadata/dataset'
// export const getDataset = (signal, id, datasetType) =>
//     fetch(`${datasetServicetUrl}/get?wellboreId=${id}&datasetType=${datasetType}`, { signal })
// export const uploadDataset = (id, datasetType, payload) =>
//     fetch(`${datasetServicetUrl}/upload?wellboreId=${id}&datasetType=${datasetType}`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(payload)
//     })

const datasetServicetUrl = '/services/plugin-adnoc-ilt/execution-data-sync/dataset'
const executionDataServicetUrl = '/services/plugin-adnoc-ilt/execution-data/sync'
const wellServiceUrl = '/services/plugin-liverig/assets/well/view/attributes'
const dvdSyncServiceUrl = '/services/plugin-adnoc-ilt/execution-data-sync/sync/dvd'
const planSyncServiceUrl = '/services/plugin-adnoc-ilt/execution-data-sync/sync/plan'
const extensionServiceUrl = '/rest/extension?area=INTEGRATION'
const interventionServiceUrl = '/services/plugin-liverig/assets/well/view/intervention'
const datasetPluginServiceUrl = '/services/plugin-datasets/dataset'

export const getDataset = (signal, id, datasetType) =>
    fetch(`${datasetServicetUrl}/get/${id}/${datasetType}`, { signal })
export const uploadDataset = (id, datasetType, payload) =>
    fetch(`${datasetServicetUrl}/upload/${id}/${datasetType}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
export const clearDataset = (id, datasetType) =>
    fetch(`${datasetServicetUrl}/clear/${id}/${datasetType}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        }
    })
export const getExecutionData = (signal, wellId, span) =>
    fetch(`${executionDataServicetUrl}/onshore/get/${wellId}/${span}`, { signal })
export const getWellAttributes = (signal, wellId) => fetch(`${wellServiceUrl}/${wellId}`, { signal })
export const getWellSyncStatus = (signal, id) => fetch(`${dvdSyncServiceUrl}/status/${id}`, { signal })
export const triggerOnDemnadSync = (id, start, end, clearData, config) =>
    fetch(
        `${dvdSyncServiceUrl}/force/${id}?start=${encodeURIComponent(start)}&end=${encodeURIComponent(
            end
        )}&clearData=${encodeURIComponent(clearData)}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(config)
        }
    )
export const getExtensionConfigs = signal => fetch(`${extensionServiceUrl}`, { signal })
export const getInterventionInfo = (signal, assetId) => fetch(`${interventionServiceUrl}/${assetId}`, { signal })
export const getDatasetStats = (signal, id, datasetType, startIndex, endIndex) =>
    fetch(`${datasetServicetUrl}/stats/${id}/${datasetType}?startIndex=${startIndex}&endIndex=${endIndex}`, { signal })
export const getAllDatasetStats = (signal, datasetType, assetType, searchValue, skip, take) =>
    fetch(
        `${datasetPluginServiceUrl}/get/attributes/all?assetType=${assetType}&datasetType=${datasetType}${
            searchValue ? '&searchWord=' + searchValue : ''
        }${skip ? '&skip=' + skip : ''}${take ? '&take=' + take : ''}`,
        {
            signal
        }
    )
export const copyDataset = (
    signal,
    wellId: string,
    fromWellId: string,
    fromWellName: string,
    startIndex: number,
    endIndex: number
) =>
    fetch(`${datasetServicetUrl}/copy/${wellId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            copyFromWellId: fromWellId,
            copyFromWellName: fromWellName,
            requestWellId: wellId,
            copyStartIndex: startIndex,
            copyEndIndex: endIndex
        })
    })

export const calculateActualForActivity = (wellId: string) => {
    return fetch(`${planSyncServiceUrl}/force/${wellId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
